export default class LoginMfaRequest {
  public constructor(
    public challengeToken: string,
    public code: string
  ){}
}
